import { PatternsConstants } from "../actions/patterns";

const handlers = {
  // Get patterns
  [PatternsConstants.PATTERNS_REQUEST]: (state: PatternsState, _action: PatternsAction): PatternsState => ({
    ...state,
    loading: true,
    errorMessage: undefined,
  }),
  [PatternsConstants.PATTERNS_SUCCESS]: (state: PatternsState, action: PatternsAction): PatternsState => {
    const payload = action.payload as PatternsResponse;
    return {
      ...state,
      patterns: payload.patterns,
      loading: false,
      errorMessage: undefined,
    };
  },
  [PatternsConstants.PATTERNS_FAILURE]: (state: PatternsState, action: PatternsAction): PatternsState => ({
    ...state,
    loading: false,
    errorMessage: action.error,
  }),

  // Get new patterns
  [PatternsConstants.NEW_PATTERNS_REQUEST]: (state: PatternsState, _action: PatternsAction): PatternsState => ({
    ...state,
    loading: true,
    errorMessage: undefined,
  }),
  [PatternsConstants.NEW_PATTERNS_SUCCESS]: (state: PatternsState, action: PatternsAction): PatternsState => {
    const payload = action.payload as NewPatternsResponse;
    return {
      ...state,
      newPatterns: payload.patterns,
      newPatternsDelayed: payload.is_delayed ?? false,
      newPatternsLocked: !!payload.locked,
      loading: false,
      errorMessage: undefined,
    };
  },
  [PatternsConstants.NEW_PATTERNS_FAILURE]: (state: PatternsState, action: PatternsAction): PatternsState => ({
    ...state,
    loading: false,
    errorMessage: action.error,
  }),

  // Get summary
  [PatternsConstants.PATTERNS_SUMMARY_REQUEST]: (state: PatternsState, _action: PatternsAction): PatternsState => ({
    ...state,
    loading: true,
    errorMessage: undefined,
  }),
  [PatternsConstants.PATTERNS_SUMMARY_SUCCESS]: (state: PatternsState, action: PatternsAction): PatternsState => ({
    ...state,
    summary: action.payload as PatternsSummaryResponse,
    loading: false,
    errorMessage: undefined,
  }),
  [PatternsConstants.PATTERNS_SUMMARY_FAILURE]: (state: PatternsState, action: PatternsAction): PatternsState => ({
    ...state,
    loading: false,
    errorMessage: action.error,
  }),

  // Get featured
  [PatternsConstants.PATTERNS_FEATURED_REQUEST]: (state: PatternsState, _action: PatternsAction): PatternsState => ({
    ...state,
    loading: true,
    errorMessage: undefined,
  }),
  [PatternsConstants.PATTERNS_FEATURED_SUCCESS]: (state: PatternsState, action: PatternsAction): PatternsState => ({
    ...state,
    featured: action.payload as PatternsFeaturedResponse,
    loading: false,
    errorMessage: undefined,
  }),
  [PatternsConstants.PATTERNS_FEATURED_FAILURE]: (state: PatternsState, action: PatternsAction): PatternsState => ({
    ...state,
    loading: false,
    errorMessage: action.error,
  }),
};

export function patterns(state: PatternsState = {}, action: PatternsAction): PatternsState {
  const handler = handlers[action.type as keyof typeof handlers] as ((state: PatternsState, action: PatternsAction) => PatternsState) | undefined;
  if (handler) {
    return handler.call(null, state, action);
  }
  return state;
}
